import * as amplitude from "@amplitude/analytics-browser";

import Platform from "@repo/utils-client/Platform";

import { Registration } from "../../client";

export default (platformKey?: Platform.Key): Registration.Analytics => {
  const platform = platformKey && Platform.Key.format(platformKey);

  amplitude.init(import.meta.env.AMPLITUDE_API_KEY);

  return {
    track(name, properties) {
      amplitude.track(name, properties, {
        platform,
      });
    },
    identify(payload) {
      if (payload.userId) amplitude.setUserId(payload.userId);

      const identify = new amplitude.Identify();
      identify.set("solidjs", true);
      if (payload.properties) {
        for (const [key, value] of Object.entries(payload.properties))
          identify.set(key, value);
      }
      amplitude.identify(identify);
    },
    anonymize() {
      amplitude.reset();
    },
  };
};
